import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(['work', 'place']),
    getByWork: state => work => {
      return state.objs.filter(wp => wp.work === work);
    },
    getByPlace: state => place => {
      return state.objs.filter(wp => wp.place === place);
    }
  },
  mutations: {
    ...functions.createDefaultMutations(['work', 'place'])
  },
  actions: {
    ...functions.createDefaultActionsWithStore(['work', 'place'])
  },
}